module.exports = __webpack_public_path__ + "img/Group 8321.b3dfd2c7.png";